var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"btn--google",attrs:{"variant":"default","href":_vm.redirectUrl}},[_c('div',{staticClass:"btn--google__content"},[_c('b-img',{attrs:{"src":"/images/google.svg"}}),_vm._v("\n    Google\n  ")],1)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cfab505","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/buttons/GoogleButton.vue
// module id = wVuC
// module chunks = 36